import { EquipmentService } from '../../../../services/equipment.service';
import { Component, OnInit, EventEmitter } from '@angular/core';
import { TableConfiguration, TableColumns, HttpService, SessionService, MessageService, params, LocalStorageService, MenuBreadCrumb, HeaderFilters } from 'brainloper-ui';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { Plan } from 'src/app/models/configuration/plan';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';


@Component({
    selector: 'app-equipment',
    templateUrl: './equipment.component.html',
    styleUrls: ['./equipment.component.scss'],
    standalone: false
})
export class EquipmentComponent implements OnInit {

  public urlGetEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_TABLE}`;
  private urlEquipo: string = `${EndpointDictionary.Equipment.CRUD_EQUIPMENT_DATA}`;
  // private urlGetComponentes: string = `${EndpointDictionary.ComponentEquipment.COMPONENT_EQUIPMENT_TABLE}`;
  // private urlDeleteComponentes: string = `${EndpointDictionary.ComponentEquipment.CRUD_COMPONENT_EQUIPMENT_DATA}`;
  private urlComboEquipmentType: string = `${EndpointDictionary.EquipmentType.EQUIPMENT_TYPE_COMBO}`
  private inactivateEquipment: string = `${EndpointDictionary.Equipment.INACTIVATE_EQUIPMENT}`;
  private activeEquipment: string = `${EndpointDictionary.Equipment.ACTIVE_EQUIPMENT}`;
  public companyId:number
  public params2: params [] = [
    {
      id: 'state',
      value: 0
    }]

    public isChecked: boolean = true
    public labelToggle:string = "Equipos activos"

    public headerFilters: HeaderFilters[] = [
      {
        tN: "tipo_equipo",
        labelFilter:"Tipo de equipo",
        urlData: this.urlComboEquipmentType,
        visibleField:"name",
        primaryKey:"id",
        type:"select",
        value:""
      }
    ]

 // private titleEquipos: string
  public recargarTablaEquipos = new EventEmitter<any>()
  public recargarTablaEquiposInactives = new EventEmitter<any>()
  public configurationEquipos: TableConfiguration = {
    edit: true,
    add: true,
    delete: false,
    selectable: true,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    active:true,
    view:true
  }
  public columnasEquipos: TableColumns<Equipment>[] = [
    {
      ID: 'code',
      label: 'Codigo',
      type: 'text',
      style: {
        textAlign: 'center'
      }
    },
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center'
      }
    },
    {
      ID: 'userName',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center'
      }
    },
    {
      ID: 'serial',
      label: 'Serial',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      }
    },
    {
      ID: 'currentOdometer',
      label: 'Medidor actual (horas/km/ciclos)',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      }
    }
  ]

  constructor(
    private http: HttpService,
    private router: Router,
    private session: SessionService,
    private activeRoute: ActivatedRoute,
    private message: MessageService,
    private deleteService: DeleteGenericService,
    private storage : LocalStorageService,

  ) {
    this.companyId = this.storage.get<number>('companyId')
   }

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Equipos",
    current:true
  }]

  ngOnInit(): void {
  }

  agregarEquipos($event:number) {

    let plan: Plan = this.storage.get('plan')
    if($event < plan.equipmentsNumber) {
      this.session.setData('redireccion', 'new')
      this.router.navigate(['detalle'], { relativeTo: this.activeRoute })
    }else{
      this.message.Warning("Limite del plan","Adquiera un nuevo plan")
    }
  }

  async editarEquipos($event:Equipment[]) {
    //console.log($event)
    let res: Array<Equipment> = await this.http.getDataBody(`${this.urlEquipo}/${$event[0].id}`)
    if (res && res.length > 0) {
      this.session.setData('equipment', res[0])
      this.session.setData('redireccion', 'update')
      this.router.navigate(['detalle'], { relativeTo: this.activeRoute })
    }
  }

  async clickFilaEquipos($event:Equipment[]) {
    //console.log($event)
    let res: Array<Equipment> = await this.http.getDataBody(`${this.urlEquipo}/${$event[0].id}`)
    if (res  && res.length > 0) {
      var datos = res[0]
      let img = `${EndpointDictionary.Base._BASE_URL_V2}${datos.photo}/${this.companyId}`
      this.session.setData('cve', { action: 'cve', dataEquipo: datos, imgEquipo: img })
      this.router.navigate(['cve'], { relativeTo: this.activeRoute })

    } else { this.message.Error('Error', res['message']) }
  }

  async inactivateOrActiveEquipment ($event:Equipment[], active:boolean) {
    if (!Array.isArray($event)) {
      $event = [$event];
    }
    await this.deleteService.inactivateOrActivate($event, active, this.activeEquipment, this.inactivateEquipment, 'Equipo')

    if(active){
     this.recargarTablaEquiposInactives.emit()
   }else{
     this.recargarTablaEquipos.emit()

   }
 }

  changeToggle($event:MatSlideToggleChange){
    if($event.checked){
      this.labelToggle = "Equipos Activos"
    }else{
      this.labelToggle = "Equipos Inactivos"
    }
  }

}
